module.exports = __webpack_public_path__ + "img/ic_device_chair.bbdcc339.png";